import { AxiosGet, AxiosPost, AxiosPut } from "../useApi";

export function GetUserGroups() {
    return AxiosGet('usergroups');
}

export function GetUserGroupsByOwner(params) { 
    return AxiosGet('usergroups/by-owner', params);
}

export function GetUserGroupById(params) {
    return AxiosGet('usergroups/by-id', params);
}

export function CreateGroup(data) {
    const route = 'usergroups';
    return AxiosPut(route, null, data);
}

export function SetUserGroup(params, body) { 
    return AxiosPost('usergroups', params, body);
}

export function AddUserToGroup(data) { 
    return AxiosPost('usergroups/add', null, data);
}

export function DeleteUserFromGroup(data) { 
    return AxiosPost('usergroups/delete', null, data);
}

export function GetScheduleByUserGroupId(params) {
    return AxiosGet('usergroups/schedule', params);
}


